export default __webpack_public_path__ + "static/media/nv10.bdd218c0.PNG";